<template>
  <div>
    <div class="modal-header">
      <div class="modal-title">{{title}}</div>
      <div class="modal-close">
        <button class="modal-close-button" name="close_modal" @click="closeModal">×</button>
      </div>
    </div>
    <div class="modal-content" v-html="content">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalComponent',
  props: {
    title: {
      type: String
    },
    content: {
      type: String
    }
  },
  methods: {
    closeModal: function () {
      this.$FModal.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/modal";
</style>



// WEBPACK FOOTER //
// src/components/assetComponents/ModalComponent.vue